document.addEventListener('DOMContentLoaded', () => {

  // ── Mobile menu ──────────────────────────────────────────────
  const menuBtn   = document.querySelector('.menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');

  if (menuBtn && mobileNav) {
    const openMenu = () => {
      const open = mobileNav.classList.toggle('is-open');
      menuBtn.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    menuBtn.addEventListener('click', openMenu);
    menuBtn.addEventListener('touchend', e => { e.preventDefault(); openMenu(); });
  }

  // Close mobile menu after nav link tap
  document.querySelectorAll('.mobile-nav a').forEach(link => {
    link.addEventListener('click', () => {
      if (mobileNav) mobileNav.classList.remove('is-open');
      if (menuBtn)   { menuBtn.classList.remove('is-open'); menuBtn.setAttribute('aria-expanded', 'false'); }
      document.body.style.overflow = '';
    });
  });

  // ── Gallery thumbs ───────────────────────────────────────────
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.gallery-main img');
      if (main) {
        main.src    = thumb.dataset.src;
        main.srcset = thumb.dataset.srcset || '';
      }
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ── Variant selector + Add to Cart ───────────────────────────
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const data     = JSON.parse(document.querySelector('[data-product-json]')?.textContent || 'null');
    const hiddenId = productForm.querySelector('[name="id"]');
    const atcBtn   = productForm.querySelector('.atc-btn');
    const priceEl  = document.querySelector('[data-price]');
    const selected = {};

    productForm.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const { name, value } = btn.dataset;
        selected[name] = value;
        productForm.querySelectorAll(`.option-btn[data-name="${name}"]`).forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        if (!data) return;
        const v = data.variants.find(variant =>
          data.options.every((opt, i) => !selected[opt] || variant[`option${i + 1}`] === selected[opt])
        );
        if (!v) return;
        if (hiddenId) hiddenId.value = v.id;
        if (atcBtn)   atcBtn.dataset.variantId = v.id;
        if (priceEl)  priceEl.textContent = '$' + (v.price / 100).toFixed(2);
        if (atcBtn) {
          atcBtn.disabled    = !v.available;
          atcBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
        }
      });
    });

    productForm.addEventListener('submit', async e => {
      e.preventDefault();
      const id = atcBtn?.dataset.variantId || hiddenId?.value;
      if (!id) return;
      atcBtn.textContent = 'Adding...';
      atcBtn.disabled    = true;
      try {
        const r = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id, quantity: 1 })
        });
        if (!r.ok) throw new Error('add failed');
        const cart = await (await fetch('/cart.js')).json();
        const el   = document.querySelector('.cart-count');
        if (el) {
          el.textContent = cart.item_count;
          el.className   = 'cart-count' + (cart.item_count > 0 ? '' : ' is-empty');
        }
        atcBtn.textContent = 'Added!';
        setTimeout(() => { atcBtn.textContent = 'Add to Cart'; atcBtn.disabled = false; }, 2000);
      } catch {
        atcBtn.textContent = 'Try Again';
        atcBtn.disabled    = false;
      }
    });
  }

  // ── Cart quantity buttons ────────────────────────────────────
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const input = btn.closest('.qty-row').querySelector('.qty-input');
      const next  = Math.max(0, parseInt(input.value, 10) + (btn.dataset.dir === 'up' ? 1 : -1));
      input.value = next;
      await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: input.dataset.key, quantity: next })
      });
      if (next === 0) { window.location.reload(); return; }
      const cart = await (await fetch('/cart.js')).json();
      const sub  = document.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = '$' + (cart.total_price / 100).toFixed(2);
    });
  });

  // ── Email capture form ───────────────────────────────────────
  const emailForm = document.querySelector('[data-email-form]');
  if (emailForm) {
    emailForm.addEventListener('submit', e => {
      e.preventDefault();
      const input = emailForm.querySelector('.email-input');
      const btn   = emailForm.querySelector('.email-submit');
      btn.textContent = "You're in.";
      btn.disabled    = true;
      input.value     = '';
    });
  }
  // ── Scroll progress bar ──────────────────────────────
const progressBar = document.createElement('div');
progressBar.className = 'scroll-progress';
document.body.prepend(progressBar);

window.addEventListener('scroll', () => {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const progress = (scrollTop / docHeight) * 100;
  progressBar.style.width = progress + '%';
}, { passive: true });

// ── Section reveal on scroll ─────────────────────────
const revealElements = document.querySelectorAll(
  '.stats-bar, .product-section, .run-command, .about-section, ' +
  '.community-section, .join-section, .email-section'
);

revealElements.forEach(el => {
  el.classList.add('section-reveal');
});

const productGrid = document.querySelector('.product-grid');
if (productGrid) productGrid.classList.add('section-reveal-stagger');

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

revealElements.forEach(el => revealObserver.observe(el));
if (productGrid) revealObserver.observe(productGrid);

// ── Stat counter animation ───────────────────────────
const statNumbers = document.querySelectorAll('.stat-number');

const countUp = (el) => {
  const text = el.textContent.trim();
  const num = parseInt(text.replace(/\D/g, ''));
  const suffix = text.replace(/[\d]/g, '');
  if (isNaN(num)) return;
  let start = 0;
  const duration = 1200;
  const step = (timestamp) => {
    if (!start) start = timestamp;
    const progress = Math.min((timestamp - start) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    el.textContent = Math.floor(eased * num) + suffix;
    if (progress < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};

const statObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      countUp(entry.target);
      statObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.5 });

statNumbers.forEach(el => statObserver.observe(el));

// ── Hero subtle parallax ─────────────────────────────
const hero = document.querySelector('.hero');
if (hero) {
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    if (scrolled < window.innerHeight) {
      hero.style.transform = `translateY(${scrolled * 0.25}px)`;
    }
  }, { passive: true });
}
});
